<template>
  <div class="machinery-panel">
    <!-- Header -->
    <div class="panel-header-bar">
      <div class="header-tabs">
        <button
          class="tab-btn"
          :class="{ active: activeSection === 'gerenciar' }"
          type="button"
          @click="activeSection = 'gerenciar'"
        >Gerenciar Maquinário</button>
        <button
          class="tab-btn"
          :class="{ active: activeSection === 'localizador' }"
          type="button"
          @click="goToLocalizador()"
        >Localizador</button>
        <button
          class="tab-btn"
          :class="{ active: activeSection === 'rdo-localizador' }"
          type="button"
          @click="activeSection = 'rdo-localizador'; loadRdoLocalizador()"
        >Localizador de RDOs</button>
      </div>
      <div class="header-actions" v-if="activeSection === 'gerenciar' && !isAnalyst">
        <button class="btn btn-primary" type="button" @click="showCategoryForm = true">+ Nova Categoria</button>
      </div>
      <div class="header-actions" v-else-if="activeSection === 'localizador'">
        <button class="btn btn-ghost" type="button" @click="exportLocalizador">Exportar PDF</button>
      </div>
      <div v-else></div>
    </div>

    <!-- Category Form Modal -->
    <div v-if="showCategoryForm" class="confirm-overlay" @click.self="showCategoryForm = false">
      <div class="confirm-card">
        <div class="confirm-title">{{ editingCategory ? 'Editar Categoria' : 'Nova Categoria' }}</div>
        <input
          v-model="categoryForm.name"
          type="text"
          class="input-field-input"
          placeholder="Nome da categoria"
          @keyup.enter="saveCategory"
        />
        <div class="confirm-actions">
          <button class="link link-inline" type="button" @click="showCategoryForm = false">Cancelar</button>
          <button class="link link-inline confirm-link" type="button" @click="saveCategory">
            {{ editingCategory ? 'Atualizar' : 'Criar' }}
          </button>
        </div>
      </div>
    </div>

    <!-- Machinery Form Modal -->
    <div v-if="showMachineryForm" class="confirm-overlay" @click.self="showMachineryForm = false">
      <div class="confirm-card" style="min-width: min(620px, calc(100vw - 32px))">
        <div class="confirm-title">{{ editingMachinery ? 'Editar Máquina' : 'Nova Máquina' }}</div>
        <div class="form-grid">
          <div class="input-field">
            <label>Título</label>
            <input v-model="machineryForm.title" type="text" class="input-field-input" placeholder="Ex: Caminhão Munck" />
          </div>
          <div class="input-field">
            <label>Capacidade (kg)</label>
            <input v-model.number="machineryForm.capacityKg" type="number" class="input-field-input" />
          </div>
          <div class="input-field">
            <label>Capacidade de Pessoas</label>
            <input v-model.number="machineryForm.capacityPeople" type="number" class="input-field-input" />
          </div>
          <div class="input-field">
            <label>Altura de Elevação (m)</label>
            <input v-model.number="machineryForm.liftingHeightMeters" type="number" step="0.1" class="input-field-input" />
          </div>
          <div class="input-field">
            <label>Categoria</label>
            <select v-model="machineryForm.categoryId" class="input-field-input">
              <option value="">Selecione uma categoria</option>
              <option v-for="cat in machineryStore.state.categories" :key="cat.id" :value="cat.id">
                {{ cat.name }}
              </option>
            </select>
          </div>
          <div class="input-field">
            <label>Status</label>
            <select v-model="machineryForm.status" class="input-field-input">
              <option value="ativo">Ativo</option>
              <option value="inativo">Inativo</option>
            </select>
          </div>
          <div class="input-field">
            <label>Notas</label>
            <textarea v-model="machineryForm.notes" class="input-field-input" placeholder="Notas opcionais"></textarea>
          </div>
        </div>
        <div class="confirm-actions">
          <button class="link link-inline" type="button" @click="showMachineryForm = false">Cancelar</button>
          <button class="link link-inline confirm-link" type="button" @click="saveMachinery">
            {{ editingMachinery ? 'Atualizar' : 'Criar' }}
          </button>
        </div>
      </div>
    </div>

    <!-- ── GERENCIAR SECTION ── -->
    <div v-if="activeSection === 'gerenciar'">
      <div v-if="machineryStore.state.categories.length === 0" class="empty-state">
        <p>Nenhuma categoria criada. Crie uma categoria para começar.</p>
      </div>
      <div v-else class="machinery-container">
        <div v-for="category in groupedMachinery" :key="category.id" class="category-section">
          <div class="category-header">
            <h3 class="category-title">{{ category.name }}</h3>
            <button v-if="!isAnalyst" class="icon-btn" type="button" title="Deletar categoria" @click="deleteCategory(category.id, category.name)">🗑</button>
          </div>
          <div class="machinery-grid">
            <div v-for="machine in category.machines" :key="machine.id" class="machine-card">
              <div class="machine-title">{{ machine.title }}</div>
              <div class="machine-meta">
                <div v-if="machine.capacityKg" class="machine-spec">Carga: {{ machine.capacityKg }}kg</div>
                <div v-if="machine.capacityPeople" class="machine-spec">Pessoas: {{ machine.capacityPeople }}</div>
                <div v-if="machine.liftingHeightMeters" class="machine-spec">Altura: {{ machine.liftingHeightMeters }}m</div>
              </div>
              <div class="machine-actions">
                <button class="btn btn-ghost" type="button" @click="goToLocalizador(machine.id)">Localizador</button>
                <button v-if="!isAnalyst" class="btn btn-ghost" type="button" @click="editMachine(machine)">Editar</button>
                <button v-if="!isAnalyst" class="btn btn-danger" type="button" @click="deleteMachine(machine.id, machine.title)">Deletar</button>
              </div>
            </div>
            <div v-if="!isAnalyst" class="machine-card machine-add" @click="openNewMachinery(category.id)">
              <div style="font-size: 32px; margin-bottom: 8px">+</div>
              <div>Adicionar Máquina</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- ── RDO LOCALIZADOR SECTION ── -->
    <div v-if="activeSection === 'rdo-localizador'" class="rdo-loc-section">
      <div v-if="rdoLoading" class="loc-loading">Carregando relatórios…</div>
      <div v-else-if="rdoError" class="loc-empty" style="color:#dc2626">{{ rdoError }}</div>
      <div v-else-if="rdoGanttRows.length === 0" class="loc-empty">
        Nenhuma ocorrência de maquinário encontrada nos relatórios.<br>
        <small>Selecione um maquinário ao criar um Relatório Diário de Obra para que ele apareça aqui.</small>
      </div>
      <template v-else>
        <!-- Filter Toggle -->
        <div class="filter-toggle-bar">
          <button class="filter-toggle-btn" type="button" @click="showRdoFilters = !showRdoFilters">
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 3H2l8 9.46V19l4 2v-8.54L22 3z"/></svg>
            Filtros
            <span v-if="rdoActiveFilterCount > 0" class="filter-active-badge">{{ rdoActiveFilterCount }}</span>
            <svg class="filter-chevron" :class="{ rotated: showRdoFilters }" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="6 9 12 15 18 9"/></svg>
          </button>
          <button v-if="rdoActiveFilterCount > 0" class="filter-clear-btn" type="button" @click="clearRdoFilters">Limpar filtros</button>
        </div>
        <!-- Filter Bar -->
        <Transition name="filter-bar">
          <div v-show="showRdoFilters" class="rdo-loc-filter-bar">
            <div class="loc-filter-group">
              <label class="loc-filter-label">Maquinário</label>
              <select class="loc-filter-input" v-model="rdoFilterMachineId">
                <option value="">Todos</option>
                <option v-for="m in rdoMachineOptions" :key="m.id" :value="m.id">{{ m.title }}</option>
              </select>
            </div>
            <div class="loc-filter-group">
              <label class="loc-filter-label">De</label>
              <input v-model="rdoFilterDateFrom" type="date" class="loc-filter-input loc-date-input" />
            </div>
            <div class="loc-filter-group">
              <label class="loc-filter-label">Até</label>
              <input v-model="rdoFilterDateTo" type="date" class="loc-filter-input loc-date-input" />
            </div>
            <div class="loc-filter-group loc-filter-zoom">
              <label class="loc-filter-label">Zoom · {{ rdoLocZoomLabel }}</label>
              <div class="loc-zoom-row">
                <input type="range" min="25" max="350" step="5" v-model.number="rdoLocZoomScale" class="loc-zoom-slider" />
                <span class="loc-zoom-value">{{ rdoLocZoomScale }}%</span>
              </div>
            </div>
          </div>
        </Transition>
        <!-- No results -->
        <div v-if="rdoVisibleRows.length === 0" class="loc-empty">
          Nenhum resultado para os filtros selecionados.
        </div>
        <!-- Gantt -->
        <div v-else class="loc-gantt-wrap">
          <div class="loc-gantt-scroll">
            <div class="loc-gantt-grid" :style="{ gridTemplateColumns: `220px repeat(${rdoVisibleDays.length}, ${rdoLocDayW}px)` }">
              <!-- Header -->
              <div class="loc-col-label loc-col-header"><span class="loc-col-header-text">Atração / Maquinário</span></div>
              <div v-for="(day, di) in rdoVisibleDays" :key="'rdoh' + di" class="loc-day-header"
                :class="{ 'loc-day-today': day === todayStr, 'loc-day-weekend': isWeekend(day) }">{{ formatDayLabel(day) }}</div>
              <!-- Rows grouped by attraction -->
              <template v-for="attr in rdoVisibleAttractions" :key="'attr-' + attr">
                <div class="loc-project-row" :style="{ gridColumn: `1 / span ${rdoVisibleDays.length + 1}` }">{{ attr }}</div>
                <template v-for="row in rdoVisibleRows.filter(r => r.attraction === attr)" :key="row.machineId + '|' + row.attraction">
                  <div class="loc-row-label">
                    <span class="loc-machine-badge" :style="{ background: row.color }">{{ row.number }}</span>
                    <div class="loc-row-label-text">
                      <span class="loc-task-name">{{ row.machineTitle }}</span>
                    </div>
                  </div>
                  <div v-for="(day, di) in rdoVisibleDays" :key="'rdoc' + di" class="loc-cell"
                    :class="{ 'loc-day-today': day === todayStr, 'loc-day-weekend': isWeekend(day) }">
                    <div v-if="row.dateSet.has(day)" class="loc-block" :style="{ background: row.color }"
                      :title="row.machineTitle + ' · ' + row.attraction"></div>
                  </div>
                </template>
              </template>
            </div>
          </div>
          <!-- Legend -->
          <div class="loc-legend">
            <div class="loc-legend-title">Legenda</div>
            <div class="loc-legend-grid">
              <div v-for="entry in rdoVisibleLegend" :key="entry.id" class="loc-legend-item">
                <span class="loc-legend-badge" :style="{ background: entry.color }">{{ entry.number }}</span>
                <span class="loc-legend-label">{{ entry.title }}</span>
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>

    <!-- ── LOCALIZADOR SECTION ── -->
    <div v-else-if="activeSection === 'localizador'" class="localizador-section">
      <!-- Filter Toggle -->
      <div class="filter-toggle-bar">
        <button class="filter-toggle-btn" type="button" @click="showLocFilters = !showLocFilters">
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 3H2l8 9.46V19l4 2v-8.54L22 3z"/></svg>
          Filtros
          <span v-if="locActiveFilterCount > 0" class="filter-active-badge">{{ locActiveFilterCount }}</span>
          <svg class="filter-chevron" :class="{ rotated: showLocFilters }" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="6 9 12 15 18 9"/></svg>
        </button>
        <button v-if="locActiveFilterCount > 0" class="filter-clear-btn" type="button" @click="clearFilters">Limpar filtros</button>
      </div>
      <!-- Filter Bar -->
      <Transition name="filter-bar">
      <div v-show="showLocFilters" class="loc-filter-bar">
        <!-- Machinery multi-select -->
        <div class="loc-filter-group loc-filter-machinery">
          <label class="loc-filter-label">Maquinário</label>
          <div class="machinery-filter-wrap">
            <div class="machinery-filter-tags">
              <span
                v-for="mid in filterMachineryIds"
                :key="mid"
                class="machinery-filter-tag"
                :style="{ background: machineryColorMap[mid] }"
              >
                {{ machineryStore.state.machinery.find(m => m.id === mid)?.title || mid }}
                <button type="button" @click="removeMachineryFilter(mid)">✕</button>
              </span>
              <span v-if="filterMachineryIds.length === 0" class="loc-all-label">Todos</span>
            </div>
            <div class="machinery-filter-dropdown-wrap">
              <input
                v-model="machineryFilterSearch"
                type="text"
                class="loc-filter-input"
                placeholder="Filtrar por maquinário..."
                @focus="machineryFilterOpen = true"
                @blur="closeMachineryFilter"
              />
              <div v-if="machineryFilterOpen" class="machinery-filter-dropdown">
                <div
                  v-for="m in filteredMachineryOptions"
                  :key="m.id"
                  class="machinery-filter-option"
                  :class="{ selected: filterMachineryIds.includes(m.id) }"
                  @mousedown.prevent="toggleMachineryFilter(m.id)"
                >
                  <span class="mf-color-dot" :style="{ background: machineryColorMap[m.id] }"></span>
                  {{ m.title }}
                  <span class="mf-check" v-if="filterMachineryIds.includes(m.id)">✓</span>
                </div>
                <div v-if="filteredMachineryOptions.length === 0" class="machinery-filter-empty">Nenhum resultado</div>
              </div>
            </div>
          </div>
        </div>

        <!-- Date from -->
        <div class="loc-filter-group">
          <label class="loc-filter-label">De</label>
          <input v-model="filterDateFrom" type="date" class="loc-filter-input loc-date-input" />
        </div>

        <!-- Date to -->
        <div class="loc-filter-group">
          <label class="loc-filter-label">Até</label>
          <input v-model="filterDateTo" type="date" class="loc-filter-input loc-date-input" />
        </div>

        <!-- Project filter -->
        <div class="loc-filter-group">
          <label class="loc-filter-label">Projeto</label>
          <select v-model="filterProjectId" class="loc-filter-input">
            <option value="">Todos os projetos</option>
            <option v-for="p in allProjects" :key="p.id" :value="p.id">{{ p.title }}</option>
          </select>
        </div>

        <!-- Zoom -->
        <div class="loc-filter-group loc-filter-zoom">
          <label class="loc-filter-label">Zoom · {{ locZoomLabel }}</label>
          <div class="loc-zoom-row">
            <input
              type="range"
              min="25"
              max="350"
              step="5"
              v-model.number="locZoomScale"
              class="loc-zoom-slider"
            />
            <span class="loc-zoom-value">{{ locZoomScale }}%</span>
          </div>
        </div>

        <button class="btn btn-ghost loc-filter-clear" type="button" @click="clearFilters">Limpar</button>
      </div>
      </Transition>

      <!-- Diagram -->
      <div v-if="locLoading" class="loc-loading">Carregando...</div>
      <div v-else-if="visibleRows.length === 0" class="loc-empty">
        Nenhum maquinário alocado em tarefas no período selecionado.
      </div>
      <div v-else class="loc-gantt-wrap">
        <div class="loc-gantt-scroll">
          <div class="loc-gantt-grid" :style="{ gridTemplateColumns: `220px repeat(${visibleDays.length}, ${locDayW}px)` }">
            <!-- Header: day labels -->
            <div class="loc-col-label loc-col-header">
              <span class="loc-col-header-text">Projeto / Tarefa</span>
            </div>
            <div
              v-for="(day, di) in visibleDays"
              :key="'h' + di"
              class="loc-day-header"
              :class="{ 'loc-day-today': day === todayStr, 'loc-day-weekend': isWeekend(day) }"
            >
              {{ formatDayLabel(day) }}
            </div>

            <!-- Rows grouped by project -->
            <template v-for="proj in visibleProjects" :key="proj.id">
              <!-- Project separator row -->
              <div class="loc-project-row" :style="{ gridColumn: `1 / span ${visibleDays.length + 1}` }">
                {{ proj.title }}
              </div>

              <!-- Task rows for this project -->
              <template v-for="row in visibleRows.filter(r => r.projectId === proj.id)" :key="row.taskId + row.machineryId">
                <div class="loc-row-label">
                  <span
                    class="loc-machine-badge"
                    :style="{ background: row.color }"
                    :title="row.machineryTitle"
                  >{{ row.number }}</span>
                  <div class="loc-row-label-text">
                    <span class="loc-task-name">{{ row.taskTitle }}</span>
                    <span class="loc-machine-name">{{ row.machineryTitle }}</span>
                  </div>
                </div>
                <div
                  v-for="(day, di) in visibleDays"
                  :key="'c' + di"
                  class="loc-cell"
                  :class="{ 'loc-day-today': day === todayStr, 'loc-day-weekend': isWeekend(day) }"
                >
                  <div
                    v-if="day >= row.plannedStart && day <= row.plannedEnd"
                    class="loc-block"
                    :style="{ background: row.color }"
                    :title="row.taskTitle + ' · ' + row.machineryTitle"
                  ></div>
                </div>
              </template>
            </template>
          </div>
        </div>

        <!-- Legend -->
        <div class="loc-legend">
          <div class="loc-legend-title">Legenda</div>
          <div class="loc-legend-grid">
            <div v-for="entry in visibleLegend" :key="entry.id" class="loc-legend-item">
              <span class="loc-legend-badge" :style="{ background: entry.color }">{{ entry.number }}</span>
              <span class="loc-legend-label">{{ entry.title }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, computed, onMounted, watch } from 'vue'
import { machineryStore, type MachineryCategory, type HeavyMachinery } from '@/store/machinery'
import { submissionsStore } from '@/store/submissions'
import { uiStore } from '@/store/ui'

const LOC_DAY_BASE = 36 // px at 100%

interface LocalizadorRow {
  machineryId: string
  machineryTitle: string
  color: string
  number: number
  projectId: string
  projectTitle: string
  taskId: string
  taskTitle: string
  plannedStart: string
  plannedEnd: string
}

interface RdoGanttRow {
  machineId: string
  machineTitle: string
  color: string
  number: number
  attraction: string
  dateSet: Set<string>
}

const MACHINERY_COLORS = [
  '#e05252', '#e07d52', '#c9a227', '#4caf50', '#2196f3',
  '#9c27b0', '#00bcd4', '#ff5722', '#607d8b', '#8bc34a',
  '#f06292', '#26a69a', '#7986cb', '#ff7043', '#66bb6a'
]

function addDays(dateStr: string, n: number): string {
  const d = new Date(dateStr + 'T00:00:00')
  d.setDate(d.getDate() + n)
  return d.toISOString().slice(0, 10)
}

function buildDayRange(start: string, end: string): string[] {
  const days: string[] = []
  let cur = start
  while (cur <= end) {
    days.push(cur)
    cur = addDays(cur, 1)
  }
  return days
}

export default defineComponent({
  name: 'HeavyMachineryView',
  props: {
    isAnalyst: { type: Boolean, default: false }
  },
  setup(props) {
    const todayStr = new Date().toISOString().slice(0, 10)

    // ── SECTION ──
    const activeSection = ref<'gerenciar' | 'localizador' | 'rdo-localizador'>('gerenciar')
    const showLocFilters = ref(false)
    const showRdoFilters = ref(false)

    // ── MANAGE STATE ──
    const showCategoryForm = ref(false)
    const showMachineryForm = ref(false)
    const editingCategory = ref(null as MachineryCategory | null)
    const editingMachinery = ref(null as HeavyMachinery | null)
    const categoryForm = ref({ name: '' })
    const machineryForm = ref({
      title: '', capacityKg: 0, capacityPeople: 0,
      liftingHeightMeters: 0, categoryId: '', status: 'ativo', notes: ''
    })

    // ── LOCALIZADOR STATE ──
    const locLoading = ref(false)
    const allRows = ref<LocalizadorRow[]>([])
    const machineryColorMap = ref<Record<string, string>>({})
    const machineryNumberMap = ref<Record<string, number>>({})

    // Filters
    const filterMachineryIds = ref<string[]>([])
    const filterDateFrom = ref('')
    const filterDateTo = ref('')
    const filterProjectId = ref('')
    const machineryFilterSearch = ref('')
    const machineryFilterOpen = ref(false)

    // Zoom
    const locZoomScale = ref(100)
    const locDayW = computed(() => Math.max(4, Math.round(LOC_DAY_BASE * locZoomScale.value / 100)))
    const locZoomLabel = computed(() => {
      if (locZoomScale.value <= 66) return 'Mês'
      if (locZoomScale.value <= 160) return 'Semana'
      return 'Dia'
    })

    // ── HELPERS ──
    const isWeekend = (day: string) => {
      const d = new Date(day + 'T00:00:00')
      return d.getDay() === 0 || d.getDay() === 6
    }
    const formatDayLabel = (day: string) => {
      const d = new Date(day + 'T00:00:00')
      return `${d.getDate()}/${d.getMonth() + 1}`
    }

    // ── LOCALIZADOR COMPUTED ──
    const filteredRows = computed(() => {
      let rows = allRows.value
      if (filterMachineryIds.value.length > 0) {
        rows = rows.filter(r => filterMachineryIds.value.includes(r.machineryId))
      }
      if (filterProjectId.value) {
        rows = rows.filter(r => r.projectId === filterProjectId.value)
      }
      return rows
    })

    const visibleDays = computed(() => {
      const rows = filteredRows.value
      if (!rows.length) return []
      const starts = rows.map(r => r.plannedStart).filter(Boolean)
      const ends = rows.map(r => r.plannedEnd).filter(Boolean)
      if (!starts.length) return []
      let minDate = starts.reduce((a: string, b: string) => a < b ? a : b)
      let maxDate = ends.reduce((a: string, b: string) => a > b ? a : b)
      if (filterDateFrom.value && filterDateFrom.value > minDate) minDate = filterDateFrom.value
      if (filterDateTo.value && filterDateTo.value < maxDate) maxDate = filterDateTo.value
      const rangeStart = minDate < todayStr ? minDate : todayStr
      const rangeEnd = maxDate > todayStr ? maxDate : todayStr
      if (rangeStart > rangeEnd) return []
      return buildDayRange(rangeStart, rangeEnd)
    })

    const visibleRows = computed(() => {
      const days = visibleDays.value
      if (!days.length) return []
      const [dMin, dMax] = [days[0], days[days.length - 1]]
      return filteredRows.value.filter(r => r.plannedStart <= dMax && r.plannedEnd >= dMin)
    })

    const allProjects = computed(() => {
      const seen = new Set<string>()
      const projects: Array<{ id: string; title: string }> = []
      for (const r of allRows.value) {
        if (!seen.has(r.projectId)) {
          seen.add(r.projectId)
          projects.push({ id: r.projectId, title: r.projectTitle })
        }
      }
      return projects
    })

    const visibleProjects = computed(() => {
      const seen = new Set<string>()
      const projects: Array<{ id: string; title: string }> = []
      for (const r of visibleRows.value) {
        if (!seen.has(r.projectId)) {
          seen.add(r.projectId)
          projects.push({ id: r.projectId, title: r.projectTitle })
        }
      }
      return projects
    })

    const visibleLegend = computed(() => {
      const seen = new Set<string>()
      const items: Array<{ id: string; title: string; color: string; number: number }> = []
      for (const r of visibleRows.value) {
        if (!seen.has(r.machineryId)) {
          seen.add(r.machineryId)
          items.push({ id: r.machineryId, title: r.machineryTitle, color: r.color, number: r.number })
        }
      }
      return items.sort((a, b) => a.number - b.number)
    })

    const filteredMachineryOptions = computed(() => {
      const q = machineryFilterSearch.value.toLowerCase().trim()
      return machineryStore.state.machinery.filter(m =>
        !q || m.title.toLowerCase().includes(q)
      )
    })

    // ── LOAD LOCALIZADOR DATA ──
    const loadLocalizadorData = async () => {
      locLoading.value = true
      allRows.value = []
      try {
        const allMachinery = machineryStore.state.machinery
        const colorMap: Record<string, string> = {}
        const numberMap: Record<string, number> = {}
        let colorIdx = 0

        for (const machine of allMachinery) {
          if (!colorMap[machine.id]) {
            colorMap[machine.id] = MACHINERY_COLORS[colorIdx % MACHINERY_COLORS.length]
            numberMap[machine.id] = colorIdx + 1
            colorIdx++
          }
        }
        machineryColorMap.value = colorMap
        machineryNumberMap.value = numberMap

        const rows: LocalizadorRow[] = []
        for (const machine of allMachinery) {
          const data = await machineryStore.getPlanning(machine.id)
          const tasks = (data?.tasks || []).filter((t) => t.plannedStart && t.plannedEnd)
          for (const task of tasks) {
            rows.push({
              machineryId: machine.id,
              machineryTitle: machine.title,
              color: colorMap[machine.id],
              number: numberMap[machine.id],
              projectId: task.projectId,
              projectTitle: task.projectTitle,
              taskId: task.id,
              taskTitle: task.title,
              plannedStart: task.plannedStart,
              plannedEnd: task.plannedEnd
            })
          }
        }
        allRows.value = rows
      } finally {
        locLoading.value = false
      }
    }

    // ── NAVIGATION ──
    const goToLocalizador = async (machineryId?: string) => {
      activeSection.value = 'localizador'
      if (allRows.value.length === 0 && !locLoading.value) {
        await loadLocalizadorData()
      }
      if (machineryId) {
        filterMachineryIds.value = [machineryId]
      } else {
        filterMachineryIds.value = []
      }
    }

    // Reload data when switching to localizador
    watch(activeSection, async (val) => {
      if (val === 'localizador' && allRows.value.length === 0 && !locLoading.value) {
        await loadLocalizadorData()
      }
    })

    // ── FILTER ACTIONS ──
    const closeMachineryFilter = () => {
      setTimeout(() => { machineryFilterOpen.value = false }, 150)
    }

    const toggleMachineryFilter = (id: string) => {
      const idx = filterMachineryIds.value.indexOf(id)
      if (idx >= 0) {
        filterMachineryIds.value = filterMachineryIds.value.filter(x => x !== id)
      } else {
        filterMachineryIds.value = [...filterMachineryIds.value, id]
      }
    }
    const removeMachineryFilter = (id: string) => {
      filterMachineryIds.value = filterMachineryIds.value.filter(x => x !== id)
    }
    const clearFilters = () => {
      filterMachineryIds.value = []
      filterDateFrom.value = ''
      filterDateTo.value = ''
      filterProjectId.value = ''
      machineryFilterSearch.value = ''
      locZoomScale.value = 100
    }

    const locActiveFilterCount = computed(() =>
      filterMachineryIds.value.length + (filterDateFrom.value ? 1 : 0) + (filterDateTo.value ? 1 : 0) + (filterProjectId.value ? 1 : 0)
    )

    // ── EXPORT PDF ──
    const exportLocalizador = () => {
      const legend = visibleLegend.value
      const days = visibleDays.value
      const projects = visibleProjects.value
      const rows = visibleRows.value

      const esc = (s: string) => String(s || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')

      const dayHeaders = days.map(day => {
        const d = new Date(day + 'T00:00:00')
        const isWk = d.getDay() === 0 || d.getDay() === 6
        const isToday = day === todayStr
        const bg = isToday ? '#fff9cc' : isWk ? '#f4f4ef' : '#ffffff'
        return `<th style="min-width:${locDayW.value}px;padding:3px 2px;font-size:10px;border:1px solid #ccc;background:${bg};text-align:center;color:#333">${d.getDate()}/${d.getMonth() + 1}</th>`
      }).join('')

      const projectRows = projects.map(proj => {
        const projTaskRows = rows.filter(r => r.projectId === proj.id)
        const projHeader = `<tr><td colspan="${days.length + 1}" style="background:#e8edf2;font-size:12px;font-weight:700;padding:6px 10px;border:1px solid #ccc;color:#1a2a3a">${esc(proj.title)}</td></tr>`
        const taskLines = projTaskRows.map(row => {
          const labelCell = `<td style="padding:4px 8px;font-size:11px;border:1px solid #ccc;white-space:nowrap;background:#fafafa;min-width:160px">
            <span style="display:inline-block;background:${row.color};color:#fff;border-radius:3px;padding:1px 5px;font-weight:700;font-size:10px;margin-right:5px">${row.number}</span>${esc(row.taskTitle)}
          </td>`
          const cells = days.map(day => {
            const d = new Date(day + 'T00:00:00')
            const isWk = d.getDay() === 0 || d.getDay() === 6
            const isToday = day === todayStr
            const bg = isToday ? '#fff9cc' : isWk ? '#f4f4ef' : '#ffffff'
            const block = (day >= row.plannedStart && day <= row.plannedEnd)
              ? `<div style="background:${row.color};width:100%;height:14px;border-radius:2px;print-color-adjust:exact;-webkit-print-color-adjust:exact"></div>`
              : ''
            return `<td style="background:${bg};border:1px solid #ccc;padding:2px;vertical-align:middle;text-align:center;print-color-adjust:exact;-webkit-print-color-adjust:exact">${block}</td>`
          }).join('')
          return `<tr>${labelCell}${cells}</tr>`
        }).join('')
        return projHeader + taskLines
      }).join('')

      const legendRows = legend.map(e =>
        `<tr><td style="padding:5px 10px">
          <span style="display:inline-block;background:${e.color};color:#fff;border-radius:3px;padding:2px 8px;font-weight:700;margin-right:8px;print-color-adjust:exact;-webkit-print-color-adjust:exact">${e.number}</span>${esc(e.title)}
        </td></tr>`
      ).join('')

      const html = `<!DOCTYPE html>
<html lang="pt-BR">
<head>
  <meta charset="UTF-8"/>
  <title>Localizador de Maquinário</title>
  <style>
    * { box-sizing: border-box; }
    body { font-family: Arial, sans-serif; padding: 20px; color: #1f1e1a; margin: 0; }
    h1 { font-size: 16px; margin: 0 0 14px; }
    h2 { font-size: 13px; margin: 20px 0 6px; }
    table { border-collapse: collapse; font-size: 11px; }
    @media print {
      body { padding: 8px; }
      * { print-color-adjust: exact !important; -webkit-print-color-adjust: exact !important; }
    }
  </style>
</head>
<body>
  <h1>Localizador de Maquinário</h1>
  <div style="overflow-x:auto">
    <table>
      <thead>
        <tr>
          <th style="padding:5px 8px;border:1px solid #ccc;background:#e8edf2;text-align:left;font-size:11px;white-space:nowrap;min-width:160px">Tarefa</th>
          ${dayHeaders}
        </tr>
      </thead>
      <tbody>${projectRows}</tbody>
    </table>
  </div>
  <h2>Legenda</h2>
  <table><tbody>${legendRows}</tbody></table>
</body>
</html>`

      const win = window.open('', '_blank')
      if (win) {
        win.document.write(html)
        win.document.close()
        setTimeout(() => win.print(), 300)
      }
    }

    // ── MANAGE ACTIONS ──
    const saveCategory = async () => {
      if (props.isAnalyst) return
      if (!categoryForm.value.name.trim()) { uiStore.toast('Nome é obrigatório', 'error'); return }
      try {
        if (editingCategory.value) {
          await machineryStore.updateCategory(editingCategory.value.id, categoryForm.value.name)
          uiStore.toast('Categoria atualizada', 'success')
        } else {
          await machineryStore.createCategory(categoryForm.value.name)
          uiStore.toast('Categoria criada', 'success')
        }
        showCategoryForm.value = false
        editingCategory.value = null
        categoryForm.value = { name: '' }
      } catch (err) { uiStore.toast(`${err}`, 'error') }
    }

    const saveMachinery = async () => {
      if (props.isAnalyst) return
      if (!machineryForm.value.title.trim()) { uiStore.toast('Título é obrigatório', 'error'); return }
      if (!machineryForm.value.categoryId) { uiStore.toast('Categoria é obrigatória', 'error'); return }
      try {
        if (editingMachinery.value) {
          await machineryStore.updateMachinery(editingMachinery.value.id, machineryForm.value)
          uiStore.toast('Máquina atualizada', 'success')
        } else {
          await machineryStore.createMachinery(machineryForm.value)
          uiStore.toast('Máquina criada', 'success')
        }
        showMachineryForm.value = false
        editingMachinery.value = null
        resetMachineryForm()
        // Reload localizador data on next visit
        allRows.value = []
      } catch (err) { uiStore.toast(`${err}`, 'error') }
    }

    const openNewMachinery = (categoryId: string) => {
      if (props.isAnalyst) return
      editingMachinery.value = null
      resetMachineryForm()
      machineryForm.value.categoryId = categoryId
      showMachineryForm.value = true
    }

    const editMachine = (machine: HeavyMachinery) => {
      if (props.isAnalyst) return
      editingMachinery.value = machine
      machineryForm.value = { ...machine, notes: machine.notes ?? '' }
      showMachineryForm.value = true
    }

    const resetMachineryForm = () => {
      machineryForm.value = { title: '', capacityKg: 0, capacityPeople: 0, liftingHeightMeters: 0, categoryId: '', status: 'ativo', notes: '' }
    }

    const deleteCategory = async (id: string, name: string) => {
      if (props.isAnalyst) return
      if (!await uiStore.confirm(`Deletar categoria "${name}"?`)) return
      try {
        await machineryStore.deleteCategory(id)
        uiStore.toast('Categoria deletada', 'success')
        allRows.value = []
      } catch (err) { uiStore.toast(`${err}`, 'error') }
    }

    const deleteMachine = async (id: string, title: string) => {
      if (props.isAnalyst) return
      if (!await uiStore.confirm(`Deletar máquina "${title}"?`)) return
      try {
        await machineryStore.deleteMachinery(id)
        uiStore.toast('Máquina deletada', 'success')
        allRows.value = []
      } catch (err) { uiStore.toast(`${err}`, 'error') }
    }

    const groupedMachinery = computed(() => {
      return machineryStore.state.categories.map(cat => ({
        id: cat.id,
        name: cat.name,
        machines: machineryStore.state.machinery.filter(m => m.categoryId === cat.id)
      }))
    })

    // ── RDO LOCALIZADOR ──
    const rdoLoading = ref(false)
    const rdoError = ref('')
    const rdoGanttRows = ref<RdoGanttRow[]>([])
    const rdoFilterMachineId = ref('')
    const rdoFilterDateFrom = ref('')
    const rdoFilterDateTo = ref('')
    const rdoLocZoomScale = ref(100)
    const rdoLocDayW = computed(() => Math.max(4, Math.round(LOC_DAY_BASE * rdoLocZoomScale.value / 100)))
    const rdoLocZoomLabel = computed(() => {
      if (rdoLocZoomScale.value <= 66) return 'Mês'
      if (rdoLocZoomScale.value <= 160) return 'Semana'
      return 'Dia'
    })

    const rdoMachineOptions = computed(() => {
      const seen = new Set<string>()
      return rdoGanttRows.value.filter(r => { if (seen.has(r.machineId)) return false; seen.add(r.machineId); return true })
        .map(r => ({ id: r.machineId, title: r.machineTitle }))
    })

    const rdoActiveFilterCount = computed(() =>
      (rdoFilterMachineId.value ? 1 : 0) + (rdoFilterDateFrom.value ? 1 : 0) + (rdoFilterDateTo.value ? 1 : 0)
    )

    const rdoFilteredRows = computed(() =>
      rdoGanttRows.value.filter(r => !rdoFilterMachineId.value || r.machineId === rdoFilterMachineId.value)
    )

    const rdoVisibleDays = computed(() => {
      const rows = rdoFilteredRows.value
      if (!rows.length) return []
      const allDates: string[] = []
      for (const row of rows) { for (const d of row.dateSet) allDates.push(d) }
      if (!allDates.length) return []
      let minDate = allDates.reduce((a, b) => a < b ? a : b)
      let maxDate = allDates.reduce((a, b) => a > b ? a : b)
      if (rdoFilterDateFrom.value && rdoFilterDateFrom.value > minDate) minDate = rdoFilterDateFrom.value
      if (rdoFilterDateTo.value && rdoFilterDateTo.value < maxDate) maxDate = rdoFilterDateTo.value
      const rangeStart = minDate < todayStr ? minDate : todayStr
      const rangeEnd = maxDate > todayStr ? maxDate : todayStr
      if (rangeStart > rangeEnd) return []
      return buildDayRange(rangeStart, rangeEnd)
    })

    const rdoVisibleRows = computed(() => {
      const days = rdoVisibleDays.value
      if (!days.length) return []
      const [dMin, dMax] = [days[0], days[days.length - 1]]
      return rdoFilteredRows.value.filter(r => {
        for (const d of r.dateSet) { if (d >= dMin && d <= dMax) return true }
        return false
      })
    })

    const rdoVisibleAttractions = computed(() => {
      const seen = new Set<string>()
      const result: string[] = []
      for (const r of rdoVisibleRows.value) {
        if (!seen.has(r.attraction)) { seen.add(r.attraction); result.push(r.attraction) }
      }
      return result
    })

    const rdoVisibleLegend = computed(() => {
      const seen = new Set<string>()
      return rdoVisibleRows.value
        .filter(r => { if (seen.has(r.machineId)) return false; seen.add(r.machineId); return true })
        .map(r => ({ id: r.machineId, title: r.machineTitle, color: r.color, number: r.number }))
        .sort((a, b) => a.number - b.number)
    })

    const clearRdoFilters = () => {
      rdoFilterMachineId.value = ''
      rdoFilterDateFrom.value = ''
      rdoFilterDateTo.value = ''
      rdoLocZoomScale.value = 100
    }

    const loadRdoLocalizador = async () => {
      if (rdoLoading.value) return
      rdoLoading.value = true
      rdoError.value = ''
      rdoGanttRows.value = []
      try {
        await submissionsStore.refresh()
        if (machineryStore.state.machinery.length === 0) {
          await machineryStore.loadMachinery()
        }
        const allMachinery = machineryStore.state.machinery
        const machineById: Record<string, string> = {}
        const colorIdxMap: Record<string, number> = {}
        let ci = 0
        for (const m of allMachinery) {
          machineById[m.id] = m.title
          if (!(m.id in colorIdxMap)) colorIdxMap[m.id] = ci++
        }

        const rowMap = new Map<string, RdoGanttRow>()
        for (const sub of submissionsStore.all()) {
          if (!sub.tools || sub.tools.length === 0) continue
          for (const tool of sub.tools) {
            const machineId = tool.text
            if (!machineId || !machineById[machineId]) continue
            const attraction = sub.attraction || '—'
            const key = `${machineId}|${attraction}`
            if (!rowMap.has(key)) {
              const idx = colorIdxMap[machineId] ?? 0
              rowMap.set(key, {
                machineId,
                machineTitle: machineById[machineId],
                color: MACHINERY_COLORS[idx % MACHINERY_COLORS.length],
                number: idx + 1,
                attraction,
                dateSet: new Set<string>()
              })
            }
            if (sub.reportDate) {
              const normalized = sub.reportDate.slice(0, 10)
              if (normalized.length === 10) rowMap.get(key)!.dateSet.add(normalized)
            }
          }
        }

        rdoGanttRows.value = Array.from(rowMap.values())
          .sort((a, b) => a.machineTitle.localeCompare(b.machineTitle) || a.attraction.localeCompare(b.attraction))
      } catch (err) {
        rdoError.value = `Erro ao carregar dados: ${err}`
      } finally {
        rdoLoading.value = false
      }
    }

    onMounted(async () => {
      await machineryStore.loadCategories()
      await machineryStore.loadMachinery()
    })

    return {
      machineryStore,
      todayStr,
      activeSection,
      // manage
      showCategoryForm, showMachineryForm, editingCategory, editingMachinery,
      categoryForm, machineryForm,
      saveCategory, saveMachinery, openNewMachinery, editMachine,
      deleteCategory, deleteMachine, groupedMachinery, resetMachineryForm,
      showLocFilters, showRdoFilters, locActiveFilterCount,
      // rdo-localizador
      rdoLoading, rdoError, rdoGanttRows, rdoFilterMachineId, rdoFilterDateFrom, rdoFilterDateTo,
      rdoMachineOptions, rdoLocZoomScale, rdoLocDayW, rdoLocZoomLabel,
      rdoActiveFilterCount, rdoFilteredRows, rdoVisibleDays, rdoVisibleRows,
      rdoVisibleAttractions, rdoVisibleLegend, clearRdoFilters,
      loadRdoLocalizador,
      // localizador
      locLoading, machineryColorMap,
      filterMachineryIds, filterDateFrom, filterDateTo, filterProjectId,
      machineryFilterSearch, machineryFilterOpen,
      filteredMachineryOptions, allProjects,
      visibleDays, visibleRows, visibleProjects, visibleLegend,
      isWeekend, formatDayLabel,
      locZoomScale, locDayW, locZoomLabel,
      goToLocalizador, closeMachineryFilter, toggleMachineryFilter, removeMachineryFilter, clearFilters,
      exportLocalizador
    }
  }
})
</script>

<style scoped lang="scss">
.machinery-panel {
  padding: 20px;
  background: var(--bg);
  min-height: 100%;
  display: flex;
  flex-direction: column;
}

/* ── HEADER ── */
.panel-header-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  gap: 16px;
  flex-shrink: 0;
}

.header-tabs {
  display: flex;
  gap: 2px;
  background: var(--card);
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  padding: 3px;
}

.tab-btn {
  background: transparent;
  border: none;
  border-radius: calc(var(--radius-lg) - 3px);
  padding: 7px 18px;
  font-size: 13px;
  font-weight: 600;
  color: var(--ink-muted);
  cursor: pointer;
  transition: all 0.15s;

  &.active {
    background: var(--accent);
    color: #fff;
  }

  &:not(.active):hover {
    background: var(--surface);
    color: var(--ink);
  }
}

.header-actions {
  display: flex;
  gap: 10px;
  align-items: center;
}

/* ── MANAGE ── */
.machinery-container {
  display: flex;
  flex-direction: column;
  gap: 32px;
}

.category-section {
  background: var(--card);
  border-radius: var(--radius-lg);
  border: 1px solid var(--border);
  padding: 24px;
}

.category-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.category-title {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: var(--ink);
}

.machinery-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  gap: 16px;
}

.machine-card {
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  transition: box-shadow 0.15s ease, border-color 0.15s ease;

  &:hover {
    box-shadow: var(--shadow-md);
    border-color: var(--border-strong);
  }

  &.machine-add {
    display: grid;
    place-items: center;
    cursor: pointer;
    color: var(--accent);
    font-weight: 600;
    &:hover { background: var(--accent-light); }
  }
}

.machine-title { font-size: 15px; font-weight: 600; color: var(--ink); }
.machine-meta { display: flex; flex-direction: column; gap: 4px; }
.machine-spec { font-size: 12px; color: var(--ink-muted); }

.machine-actions {
  display: flex;
  gap: 6px;
  margin-top: 8px;
  flex-wrap: wrap;
  .btn { flex: 1; font-size: 12px; padding: 6px 10px; }
}

/* ── FORMS ── */
.empty-state {
  text-align: center;
  padding: 48px 20px;
  color: var(--ink-muted);
  font-size: 14px;
}

.form-grid {
  display: grid;
  gap: 16px;
  margin-bottom: 20px;
}

.input-field {
  display: grid;
  gap: 5px;
  label { font-size: 13px; font-weight: 600; color: var(--ink-muted); }
  input, select, textarea {
    border: 1px solid var(--border-strong);
    border-radius: var(--radius);
    padding: 8px 10px;
    font-size: 14px;
    background: var(--surface);
    color: var(--ink);
    font-family: inherit;
    &:focus { outline: none; border-color: var(--accent); box-shadow: 0 0 0 3px var(--accent-light); }
  }
  textarea { min-height: 80px; resize: vertical; }
}

.input-field-input {
  border: 1px solid var(--border-strong);
  border-radius: var(--radius);
  padding: 8px 10px;
  font-size: 14px;
  background: var(--surface);
  color: var(--ink);
  width: 100%;
  &:focus { outline: none; border-color: var(--accent); box-shadow: 0 0 0 3px var(--accent-light); }
}

.confirm-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: grid;
  place-items: center;
  z-index: 100;
}

.confirm-card {
  background: var(--surface);
  color: var(--ink);
  border-radius: var(--radius-xl);
  border: 1px solid var(--border-strong);
  padding: 24px 28px;
  box-shadow: var(--shadow-lg);
  min-width: min(480px, calc(100vw - 32px));
  display: grid;
  gap: 20px;
}

.confirm-title { font-size: 18px; font-weight: 700; }
.confirm-actions { display: flex; justify-content: flex-end; gap: 10px; }

.link {
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 6px 10px;
  font-size: 14px;
  color: var(--ink);
  &.confirm-link { color: var(--accent); font-weight: 600; &:hover { text-decoration: underline; } }
}

.icon-btn {
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 4px 8px;
  font-size: 16px;
  border-radius: var(--radius);
  &:hover { background: var(--card); }
}

/* ── LOCALIZADOR SECTION ── */
.localizador-section {
  display: flex;
  flex-direction: column;
  gap: 16px;
  flex: 1;
  min-height: 0;
}

/* Filter bar */
.loc-filter-bar {
  display: flex;
  gap: 12px;
  align-items: flex-end;
  flex-wrap: wrap;
  background: var(--card);
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  padding: 14px 16px;
}

.loc-filter-group {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 120px;

  &.loc-filter-machinery {
    flex: 1;
    min-width: 260px;
  }
}

.loc-filter-label {
  font-size: 11px;
  font-weight: 700;
  color: var(--ink-muted);
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.loc-filter-input {
  border: 1px solid var(--border-strong);
  border-radius: var(--radius);
  padding: 7px 10px;
  font-size: 13px;
  background: var(--surface);
  color: var(--ink);
  font-family: inherit;
  width: 100%;
  &:focus { outline: none; border-color: var(--accent); box-shadow: 0 0 0 3px var(--accent-light); }
}

.loc-date-input { width: 140px; }

.loc-filter-zoom {
  min-width: 180px;
}

.loc-zoom-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.loc-zoom-slider {
  flex: 1;
  cursor: pointer;
  accent-color: var(--accent);
}

.loc-zoom-value {
  font-size: 12px;
  color: var(--ink-muted);
  min-width: 38px;
  text-align: right;
}

.loc-filter-clear {
  align-self: flex-end;
  flex-shrink: 0;
  font-size: 12px;
  padding: 7px 14px;
}

.loc-all-label {
  font-size: 12px;
  color: var(--ink-muted);
  font-style: italic;
  padding: 2px 4px;
}

/* Machinery multi-select */
.machinery-filter-wrap {
  display: flex;
  flex-direction: column;
  gap: 6px;
  position: relative;
}

.machinery-filter-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  min-height: 24px;
}

.machinery-filter-tag {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  background: var(--accent);
  color: #fff;
  border-radius: 12px;
  padding: 2px 10px 2px 10px;
  font-size: 12px;
  font-weight: 600;

  button {
    background: none;
    border: none;
    color: rgba(255,255,255,0.8);
    cursor: pointer;
    padding: 0;
    font-size: 11px;
    line-height: 1;
    &:hover { color: #fff; }
  }
}

.machinery-filter-dropdown-wrap {
  position: relative;
}

.machinery-filter-dropdown {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  background: var(--surface);
  border: 1px solid var(--border-strong);
  border-radius: var(--radius);
  box-shadow: var(--shadow-md);
  z-index: 50;
  max-height: 200px;
  overflow-y: auto;
}

.machinery-filter-option {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  font-size: 13px;
  cursor: pointer;
  color: var(--ink);
  transition: background 0.1s;

  &:hover { background: var(--card); }
  &.selected { background: color-mix(in srgb, var(--accent) 8%, var(--surface)); }
}

.mf-color-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  flex-shrink: 0;
}

.mf-check {
  margin-left: auto;
  color: var(--accent);
  font-weight: 700;
  font-size: 12px;
}

.machinery-filter-empty {
  padding: 10px 12px;
  font-size: 13px;
  color: var(--ink-muted);
  font-style: italic;
}

/* ── GANTT GRID ── */
.loc-loading,
.loc-empty {
  color: var(--ink-muted);
  font-size: 14px;
  padding: 32px 0;
  text-align: center;
}

.loc-gantt-wrap {
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  gap: 12px;
  min-height: 0;
}

.loc-gantt-scroll {
  overflow: auto;
  flex: 1;
  border: 1px solid var(--border);
  border-radius: var(--radius);
  min-height: 200px;
}

.loc-gantt-grid {
  display: grid;
  min-width: max-content;
}

.loc-col-label {
  position: sticky;
  left: 0;
  z-index: 3;
  background: var(--surface);
  border-right: 2px solid var(--border-strong);
  border-bottom: 1px solid var(--border);
}

.loc-col-header {
  display: flex;
  align-items: center;
  padding: 0 10px;
  position: sticky;
  top: 0;
  z-index: 4;
}

.loc-col-header-text {
  font-size: 11px;
  font-weight: 700;
  color: var(--ink-muted);
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.loc-day-header {
  padding: 6px 2px;
  font-size: 10px;
  font-weight: 600;
  color: var(--ink-muted);
  text-align: center;
  border-bottom: 1px solid var(--border);
  border-right: 1px solid var(--border);
  background: var(--surface);
  position: sticky;
  top: 0;
  z-index: 2;

  &.loc-day-today { background: #fff9cc; color: #a07800; }
  &.loc-day-weekend { background: var(--card); }
}

.loc-project-row {
  font-size: 12px;
  font-weight: 700;
  color: var(--ink);
  background: var(--card);
  border-bottom: 2px solid var(--border-strong);
  border-top: 1px solid var(--border-strong);
  padding: 5px 10px;
  position: sticky;
  left: 0;
}

.loc-row-label {
  position: sticky;
  left: 0;
  z-index: 1;
  background: var(--surface);
  padding: 5px 8px;
  border-right: 2px solid var(--border-strong);
  border-bottom: 1px solid var(--border);
  display: flex;
  align-items: center;
  gap: 7px;
  min-height: 36px;
}

.loc-machine-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 3px;
  color: #fff;
  font-weight: 700;
  font-size: 11px;
  flex-shrink: 0;
}

.loc-row-label-text {
  display: flex;
  flex-direction: column;
  gap: 1px;
  overflow: hidden;
}

.loc-task-name {
  font-size: 12px;
  font-weight: 600;
  color: var(--ink);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 160px;
}

.loc-machine-name {
  font-size: 10px;
  color: var(--ink-muted);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 160px;
}

.loc-cell {
  border-right: 1px solid var(--border);
  border-bottom: 1px solid var(--border);
  min-height: 36px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 3px;

  &.loc-day-today { background: rgba(255, 249, 204, 0.5); }
  &.loc-day-weekend { background: rgba(0,0,0,0.02); }
}

.loc-block {
  width: 100%;
  height: 22px;
  border-radius: 3px;
}

/* Legend */
.loc-legend {
  flex-shrink: 0;
  padding: 12px 16px;
  background: var(--card);
  border: 1px solid var(--border);
  border-radius: var(--radius);
}

.loc-legend-title {
  font-size: 12px;
  font-weight: 700;
  color: var(--ink-muted);
  text-transform: uppercase;
  letter-spacing: 0.04em;
  margin-bottom: 8px;
}

.loc-legend-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 20px;
}

.loc-legend-item {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  color: var(--ink);
}

.loc-legend-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 18px;
  border-radius: 3px;
  color: #fff;
  font-weight: 700;
  font-size: 11px;
  flex-shrink: 0;
}

.loc-legend-label { font-size: 13px; }

/* ── RDO LOCALIZADOR ── */
.rdo-loc-section {
  display: flex;
  flex-direction: column;
  gap: 16px;
  flex: 1;
}

.rdo-loc-filter-bar {
  display: flex;
  gap: 12px;
  align-items: flex-end;
  flex-wrap: wrap;
  background: var(--card);
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  padding: 14px 16px;
}

.rdo-loc-table-wrap {
  background: var(--card);
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  overflow: auto;
}

.rdo-loc-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;

  th {
    padding: 10px 14px;
    text-align: left;
    font-size: 11px;
    font-weight: 700;
    color: var(--ink-muted);
    text-transform: uppercase;
    letter-spacing: 0.04em;
    border-bottom: 1.5px solid var(--border-strong);
    background: var(--surface);
    white-space: nowrap;
  }

  td {
    padding: 10px 14px;
    border-bottom: 1px solid var(--border);
    color: var(--ink);
    vertical-align: middle;
  }

  tr:last-child td { border-bottom: none; }
  tr:hover td { background: var(--surface); }
}

.rdo-machine-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 3px;
  color: #fff;
  font-weight: 700;
  font-size: 11px;
  margin-right: 6px;
  flex-shrink: 0;
}

.rdo-date {
  font-size: 12px;
  color: var(--ink-muted);
  white-space: nowrap;
}

/* ── FILTER TOGGLE (shared by localizador & rdo-localizador) ── */
.filter-toggle-bar {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 2px 0;
}

.filter-toggle-btn {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  background: var(--card);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  padding: 7px 14px;
  font-size: 13px;
  font-weight: 600;
  color: var(--ink);
  cursor: pointer;
  transition: background 0.12s;

  &:hover { background: var(--surface); }
}

.filter-active-badge {
  background: var(--accent);
  color: #fff;
  border-radius: 10px;
  padding: 1px 7px;
  font-size: 11px;
  font-weight: 700;
}

.filter-chevron {
  transition: transform 0.18s;
  color: var(--ink-muted);

  &.rotated { transform: rotate(180deg); }
}

.filter-clear-btn {
  background: none;
  border: none;
  color: var(--ink-muted);
  font-size: 12px;
  cursor: pointer;
  padding: 4px 8px;

  &:hover { color: var(--ink); text-decoration: underline; }
}

.filter-bar-enter-active,
.filter-bar-leave-active {
  transition: opacity 0.18s, transform 0.18s;
  overflow: hidden;
}

.filter-bar-enter-from,
.filter-bar-leave-to {
  opacity: 0;
  transform: translateY(-6px);
}
</style>
